const Utils = {


    formatSumUZS: (amount) => {
        if (amount == null) return '';
        const isNegative = amount < 0;
        const absValue = Math.abs(amount);
        const formatted = absValue.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
        return (isNegative ? '-' : '') + formatted;
    },

    getDayDifference: (start, end) => {
        try {
            if (!start || !end) return '';
            const startDate = new Date(start);
            const endDate = new Date(end);

            if (isNaN(startDate.getTime()) || isNaN(endDate.getTime())) return '';

            const diffInMs = endDate - startDate;
            const diffInDays = Math.ceil(diffInMs / (1000 * 60 * 60 * 24));

            return diffInDays;
        } catch (error) {
            console.warn('getDayDifference error:', error);
            return '';
        }
    }
};

export default Utils;
